<!-- new theme implementation starts -->
<div class="subheader with-padding flgrow">
  <div class="row align-items-center">
    <div class="col-sm-3">
      <div class="flmid">
        <div class="input-group">
          <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}"
            [(ngModel)]="pService.searchTerm" autocomplete="off" />
          <div class="input-group-append">
            <button type="button" class="btn btn-primary">
              <em class="fa fa-search"></em>
            </button>
          </div>
        </div>

      </div>

    </div>
    <div class="col-sm-3 pl-4">
      <div class="relative">
        <ng-select [multiple]="true" placeholder="{{ 'lblSelectVehical' | translate }}" [(ngModel)]="SelectedVehical"
          (change)="SerchByVehicalType()">
          <ng-template ng-header-tmp>
            <span class="mbold w-66px">Code</span>
            <span class="mbold" translate>lblVehicalType</span>
          </ng-template>

          <ng-option *ngFor="let item of vehicleTypes" [value]="item.code">
            <span class="w-66px">{{item.code}}</span>
            <span class="mx-2 hide-ng-dropdown-panel">-</span>
            <span>{{item.name}}</span>
          </ng-option>
        </ng-select>


      </div>
    </div>
    <div class="col-auto ml-auto" *ngIf="userRoleRightsDetails.canAdd">
      <button class="mr-2" (click)="exportAsXLSX()" ngbTooltip="{{'lblExportExcel' | translate}}" placement="bottom">
        <img src="./../../../assets/images/excel.png" height="32" width="32" alt="" />
      </button>
      <button type="button" type="reset" class="add-button btn btn-primary" aria-label="Center Align" translate
        (click)="onAdd()">lblAddSpecialTool</button>
    </div>

  </div>
</div>

<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <div class="card-header d-flex">
          <h4 class="card-title" translate>lblSpecialTools</h4>
        </div>
        <div class="table-responsive">


          <table class="tablest1" aria-describedby="specialtools">
            <thead>
              <tr>
                <th style="width: 55px" scope="col">#</th>
                <th scope="col" sortable="brand" (sort)="onSort($event)" translate>lblBrand</th>
                <th style="width: 20%" scope="col" translate>lblVehicalType</th>
                <th style="width: 10%" scope="col" translate>lblPartNumber</th>
                <th style="width: 20%" scope="col" translate>lblDescription</th>
                <th style="width: 10%" scope="col" translate>lblGroup</th>
                <th style="width: 15%" scope="col" translate>lblSpecialToolType</th>
                <th style="width: 120px" scope="col" class="text-center" translate>lblAction</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngIf="specialToolList?.length>0; else load_else">
                <tr *ngFor="let tool of specialToolList; let i=index">
                  <td>{{ tool.rowNumber }}</td>
                  <td>
                    <ngb-highlight [result]="tool.brand" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="tool.vehicleType" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="tool.partNumber" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="tool.partDescription" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="tool.partGroup" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td>
                    <ngb-highlight [result]="tool.type" [term]="pService.searchTerm"></ngb-highlight>
                  </td>
                  <td class="nowrap text-center">

                      <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert"
                        *ngIf="userRoleRightsDetails.canEdit" (click)="onEdit(tool.id)">
                        <em class="fas fa-pencil-alt fa-lg"></em>
                      </a>
                      <span class="ico-div" *ngIf="userRoleRightsDetails.canDelete"></span>
                      <a class="btn btn-ico" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert"
                        *ngIf="userRoleRightsDetails.canDelete" (click)="deleteSpecialTool(tool.id)">
                        <em class="far fa-trash-alt fa-lg"></em>
                      </a>




                  </td>
                </tr>
              </ng-container>
              <ng-template #load_else>
                <tr>
                  <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
        <div class="card-footer">
          <div class="d-flex justify-content-between">
            <div class="d-flex justify-content-between">
              <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page"
                [pageSize]="pService.pageSize" [maxSize]="3">
              </ngb-pagination>
              <select class="custom-select mx-2" style="width: auto" name="pageSize" [(ngModel)]="pService.pageSize">
                <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>{{item.label}}
                </option>
              </select>
            </div>
            <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0;">
              <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$ | async}}&nbsp;<span
                class="font17 fontnormal" translate>lblResults</span>
            </div>

          </div>
        </div>
      </div>

    </div>
  </div>

</div>
<!-- new theme implementation ends -->

<!-- pdf view-->
<div id="content" *ngIf="false">
  <div class="pdf">
    <br>
    <hr>
    <div class="imgclass">
      <img src="./../../../../assets/images/autofacets.png"
        onError="this.onerror=null; this.src='./../../../../assets/images/no-image-icon.png'" alt="">
    </div>
    <hr>
    <div class="pdfheader">
      <div class="ml15">
        Special Tool Report
      </div>
      <div>
        {{ currentDateTime | async | date:'dd-MM-yyyy'}}
      </div>
    </div>
    <br>
    <table class="table table-bordered ml30 tableWidth" aria-describedby="specialtool">
      <thead>
        <tr>
          <th scope="col" class="pdfTable" translate>lblBrand</th>
          <th scope="col" class="pdfTable" translate>PC</th>
          <th scope="col" class="pdfTable" translate>LCV</th>
          <th scope="col" class="pdfTable" translate>Truck/Bus</th>
          <th scope="col" class="pdfTable" translate>PartNumber</th>
          <th scope="col" class="pdfTable" translate>PartDescrption</th>
          <th scope="col" class="pdfTable" translate>Group</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="excelExportData?.length>0;">
          <tr *ngFor="let tool of excelExportData; let i=index" class="pdffont">
            <th scope="row">{{tool.Brand}}</th>
            <td>{{tool.Pc}}</td>
            <td>{{tool.Lcv}}</td>
            <td>{{tool.Truck}}</td>
            <td>{{tool.PartNumber}}</td>
            <td>{{tool.PartDescription}}</td>
            <td>{{tool.PartGroup}}</td>
          </tr>
        </ng-container>

      </tbody>
    </table>
  </div>

</div>
